import { numberFormat as numberFormatFunc } from '../utils';

const numberFormat = (num) => {
    if (!Number.isNaN(num)) {
        return numberFormatFunc(num);
    }

    return num;
};

export default numberFormat;
